module.exports = __webpack_public_path__ + "static/img/roster.9a5ce647.svg";